import {Component} from "@angular/core";
import {PageEvent} from "@angular/material/paginator";
import {Observable} from "rxjs";
import {MtxGridColumn} from "@ng-matero/extensions/grid";
import {Sort} from "@angular/material/sort";

@Component({template: ''})
export abstract class BaseTableComponent<Items> {

  protected items: Array<Items> = []
  protected resultsLength = 0;
  protected isLoadingResults = true;
  protected isRateLimitReached = false;

  protected pageSize = 25;
  protected pageIndex = 0;
  protected pageSizeOptions = [25, 50, 100];

  protected sort : Sort | null = null
  protected rowSelectable = false
  protected selectedIds: string[] = []


  searchQuery: string = ""

  abstract columns: MtxGridColumn[]

  handlePageEvent(e: PageEvent) {
    this.pageIndex = e.pageIndex
    this.pageSize = e.pageSize
    this.load()
  }

  protected constructor() {
  }

  abstract load(): void

  ngAfterViewInit() {
    this.load()
    this.rowSelectable = false
    this.selectedIds = []
  }

  protected paging<T>(call: Observable<T>,
                      mapper: (data: T) => Array<Items>,
                      total: (data: T) => number) {

    this.isLoadingResults = true;
    call.subscribe(data => {

      this.isLoadingResults = false;
      this.isRateLimitReached = data === null;
      if (data === null) {
        this.items = []
      } else {
        this.resultsLength = total(data);
        this.items = mapper(data);
      }
    })
  }

  changeSelect(e: any) {
    console.log(e + "aaaa");
  }

  changeSort(e: Sort) {
    this.sort = e
    this.load()
    this.rowSelectable = false
    this.selectedIds = []
    console.log(e)
  }

  switchRowSelect() {
    this.rowSelectable = !this.rowSelectable
    this.selectedIds = []
  }
}
